import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const FilterIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" width="20px" {...props}>
    <path
      fill="currentColor"
      d="M4,11c1.8,0,3.4-1.2,3.9-3H23c0.6,0,1-0.4,1-1s-0.4-1-1-1H7.9C7.3,3.9,5.1,2.6,3,3.1S-0.4,5.9,0.1,8
	C0.6,9.8,2.2,11,4,11z M4,5c1.1,0,2,0.9,2,2S5.1,9,4,9S2,8.1,2,7S2.9,5,4,5z M20,13c-1.8,0-3.4,1.2-3.9,3H1c-0.6,0-1,0.4-1,1
	s0.4,1,1,1h15.1c0.6,2.1,2.7,3.4,4.9,2.9c2.1-0.6,3.4-2.7,2.9-4.9C23.4,14.2,21.8,13,20,13z M20,19c-1.1,0-2-0.9-2-2s0.9-2,2-2
	s2,0.9,2,2S21.1,19,20,19z"
    />
  </IconWrapper>
);

export default memo(FilterIcon);
